var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-select", {
    staticClass: "soli-round",
    attrs: {
      value: _setup.props.value,
      items: [
        { value: "forever", description: "Forever" },
        { value: "1", description: "1 Month" },
        { value: "2", description: "2 Months" },
        { value: "3", description: "3 Months" },
        { value: "4", description: "4 Months" },
        { value: "5", description: "5 Months" },
        { value: "6", description: "6 Months" },
        { value: "7", description: "7 Months" },
        { value: "8", description: "8 Months" },
        { value: "9", description: "9 Months" },
        { value: "10", description: "10 Months" },
        { value: "11", description: "11 Months" },
        { value: "12", description: "12 Months" },
      ],
      rules: [(val) => !!val || "Required"],
      disabled: _vm.disabled,
      outlined: "",
      dense: "",
      "item-text": "description",
      "item-value": "value",
      "prepend-inner-icon": "date_range",
      label: "Discount Duration",
      "hide-details": "auto",
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }